var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introWrap",class:_vm.cooper?'bg':'nobg'},[_c('p',{staticClass:"altitle title"},[_vm._v(_vm._s(_vm.getData.title))]),_c('div',[_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.getData.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }